<template>
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 8.16667V21.5M1 8.16667L11 1.5L21 8.16667H1ZM1 21.5H21H1ZM4.33333 8.16667V21.5V8.16667ZM17.6667 8.16667V21.5V8.16667Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
    export default {
	    name: 'BankIconSVG'
    }
</script>

